var _path, _path2, _ellipse, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferallogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 127,
    viewBox: "0 0 112 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.0582 11.1041C71.5557 10.7724 73.1089 10.5979 74.701 10.5979C87.0117 10.5979 96.9915 21.0318 96.9915 33.9026C96.9915 46.7735 87.0117 57.2073 74.701 57.2073C71.1862 57.2073 67.8615 56.3569 64.9048 54.842",
    stroke: "#D9D9D9",
    strokeOpacity: 0.4,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1713 117.459H105.207C106.363 117.459 107.471 116.8 108.289 115.627C109.106 114.455 109.565 112.864 109.565 111.206V104.954C109.565 95.0041 106.81 85.462 101.907 78.4266C97.0027 71.3912 90.3517 67.4387 83.4167 67.4387H70.0586",
    stroke: "#D9D9D9",
    strokeOpacity: 0.4,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.4118,
    cy: 31.4015,
    rx: 4.33176,
    ry: 5.45672,
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5658 56.1287C56.499 56.1287 67.7941 44.3196 67.7941 29.7524C67.7941 15.1853 56.499 3.37622 42.5658 3.37622C28.6325 3.37622 17.3374 15.1853 17.3374 29.7524C17.3374 44.3196 28.6325 56.1287 42.5658 56.1287Z",
    stroke: "#D9D9D9",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.025 110.168V117.244C82.025 119.121 81.5053 120.921 80.5803 122.248C79.6553 123.575 78.4007 124.321 77.0925 124.321H8.03794C6.72977 124.321 5.47517 123.575 4.55016 122.248C3.62514 120.921 3.10547 119.121 3.10547 117.244V110.168C3.10547 98.9069 6.22349 88.1072 11.7736 80.1445C17.3237 72.1819 24.8512 67.7085 32.7003 67.7085H52.4302C60.2792 67.7085 67.8068 72.1819 73.3569 80.1445C78.907 88.1072 82.025 98.9069 82.025 110.168Z",
    stroke: "#D9D9D9",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5552 21.071C34.0173 21.071 36.1333 23.6164 36.1333 26.9216C36.1333 30.227 34.0174 32.7722 31.5552 32.7722C29.0931 32.772 26.978 30.2268 26.978 26.9216C26.9781 23.6165 29.0932 21.0713 31.5552 21.071Z",
    fill: "#D9D9D9",
    fillOpacity: 0.9,
    stroke: "#D9D9D9",
    strokeWidth: 0.650094
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.896 21.071C50.3582 21.071 52.4741 23.6164 52.4741 26.9216C52.4741 30.227 50.3582 32.7722 47.896 32.7722C45.434 32.772 43.3188 30.2268 43.3188 26.9216C43.3189 23.6165 45.434 21.0713 47.896 21.071Z",
    fill: "#D9D9D9",
    fillOpacity: 0.9,
    stroke: "#D9D9D9",
    strokeWidth: 0.650094
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferallogo);
export default __webpack_public_path__ + "static/media/referal logo.874dacd540003b74b5019dc5ea63719a.svg";
export { ForwardRef as ReactComponent };